import { Flex } from "@chakra-ui/react";
import * as React from "react";

export default function Sidebar({ children }: { children: React.ReactNode }) {
  return (
    <Flex
      bg="navy"
      borderRadius="xl"
      borderRightWidth="1"
      direction="column"
      m="1"
      w={"280px" as any}
    >
      {children}
    </Flex>
  );
}
